const vacationCategories: Record<string, string[]> = {
    BASE: ['Bay'],
    LINE: ['A vakt', 'B vakt', 'C vakt', 'D vakt'],
    SHOP: [
        'Avionics Shop', 'Component shop', 'Composite shop', 'Engine Shop',
        'Exterior Cleaning', 'Interior Cleaning', 'Interior Shop', 'NDT shop',
        'Paint Shop', 'Sheet Metal Shop', 'Tool Clerk', 'Tool Shop'
    ]
};

export {
    vacationCategories
}